import {createApp} from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/index.scss'
import '@/styles/var.css'
import router from '@/router/index'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import {storeInit} from "@/store";

storeInit()


const app = createApp(App)
app.use(ElementPlus, {
    locale: zhCn,
})
app.use(router)
app.mount('#app')